import { render, staticRenderFns } from "./ProjectListProjectLeaders.vue?vue&type=template&id=f6e5bb00&"
import script from "./ProjectListProjectLeaders.vue?vue&type=script&lang=js&"
export * from "./ProjectListProjectLeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports